import { appState, dispatchStateEvent } from '../../store/appState.js';
import { createCategory, createTag } from '../../api/categories.js'; 
import { createWallet as createWalletApi } from '../../api/wallets.js';
import { saveTransactionToDB, updateTransactionFull, saveTransferToDB, deleteTransactionAndRefund } from '../../api/transactions.js';
import { showToast } from '../../utils/toast.js';
import { renderTransactionsTab } from '../tabs/transactionsTab.js';

export function initTransactionModal() {
    const btnFab = document.getElementById('btn-fab');
    const txnModal = document.getElementById('txn-modal');
    const txnModalContent = document.getElementById('txn-modal-content');
    const btnCloseModal = document.getElementById('btn-close-modal');
    const typeBtns = document.querySelectorAll('.type-btn');
    const btnSaveTxn = document.getElementById('btn-save-txn');

    if(!btnFab) return;

    // Lắng nghe event "updateFormDisplay" từ các js khác truyền tới
    window.addEventListener('updateFormDisplay', updateFormDisplay);

    function updateFormDisplay() {
        document.getElementById('display-wallet').innerText = appState.formState.wallet.name;
        document.getElementById('display-category').innerText = appState.formState.category.name;
        document.getElementById('display-tag').innerText = appState.formState.tag.name;
        
        const isTransfer = appState.currentTxnType === 'transfer';
        const displayWalletTo = document.getElementById('display-wallet-to');
        if (displayWalletTo && appState.formState.walletTo) {
            displayWalletTo.innerText = appState.formState.walletTo.name;
        }

        const btnSelectCategory = document.getElementById('btn-select-category');
        const btnSelectTag = document.getElementById('btn-select-tag');
        const btnSelectWalletTo = document.getElementById('btn-select-wallet-to');
        const btnSelectWallet = document.getElementById('btn-select-wallet');
        const labelWalletFrom = document.getElementById('label-wallet-from');
        const transferRateContainer = document.getElementById('transfer-rate-container');

        if (isTransfer) {
            if (btnSelectCategory) btnSelectCategory.classList.add('hidden');
            if (btnSelectTag) btnSelectTag.classList.add('hidden');
            if (btnSelectWalletTo) btnSelectWalletTo.classList.remove('hidden');
            if (labelWalletFrom) labelWalletFrom.innerText = 'From Wallet';
            if (btnSelectWallet) {
                btnSelectWallet.classList.remove('col-span-2');
            }

            // Check if currencies are different
            const fromCur = appState.formState.wallet.currency;
            const toCur = appState.formState.walletTo ? appState.formState.walletTo.currency : 'VND';
            
            if (fromCur && toCur && fromCur !== toCur) {
                if (transferRateContainer) transferRateContainer.classList.remove('hidden');
            } else {
                if (transferRateContainer) transferRateContainer.classList.add('hidden');
            }
        } else {
            if (btnSelectCategory) btnSelectCategory.classList.remove('hidden');
            if (btnSelectTag) btnSelectTag.classList.remove('hidden');
            if (btnSelectWalletTo) btnSelectWalletTo.classList.add('hidden');
            if (labelWalletFrom) labelWalletFrom.innerText = 'Wallet';
            if (btnSelectWallet) {
                btnSelectWallet.classList.add('col-span-2');
            }
            if (transferRateContainer) transferRateContainer.classList.add('hidden');
        }
    }

    // Mở Form
    btnFab.addEventListener('click', () => {
        // Nếu người dùng TỰ BẤM (Tạo mới) chứ không phải do hàm Edit tự động gọi
        if (!appState.editingTxnId) {
            document.getElementById('btn-save-txn').innerText = "Save Transaction";
            
            // 1. Reset trắng ô nhập liệu
            document.getElementById('txn-amount').value = '';
            document.getElementById('txn-remark').value = '';
            
            // 2. Reset trạng thái chọn Ví/Danh mục/Tag
            appState.formState = { 
                wallet: { id: null, name: 'Select...', currency: 'VND' }, 
                walletTo: { id: null, name: 'Select...', currency: 'VND' }, 
                category: { id: null, name: 'Select...' }, 
                tag: { id: null, name: 'Optional...' } 
            };
            
            const trfRate = document.getElementById('txn-transfer-amount');
            if(trfRate) trfRate.value = '';

            updateFormDisplay();
            
            // 3. Set ngày về hôm nay
            document.getElementById('txn-date').value = new Date().toISOString().split('T')[0];
        }
        
        // Mở Modal (Animation)
        txnModal.classList.remove('hidden');
        txnModal.classList.add('flex');
        setTimeout(() => {
            txnModalContent.classList.remove('translate-y-full');
            txnModalContent.classList.add('translate-y-0');
        }, 10);
    });

    // Đóng Form 
    btnCloseModal.addEventListener('click', () => {
        txnModalContent.classList.remove('translate-y-0');
        txnModalContent.classList.add('translate-y-full');
        setTimeout(() => {
            txnModal.classList.add('hidden');
            txnModal.classList.remove('flex');
            
            // Xóa bỏ trạng thái Edit nếu người dùng hủy
            appState.editingTxnId = null;
            document.getElementById('btn-save-txn').innerText = "Save Transaction";
        }, 300);
    });

    // Logic khi bấm đổi Loại Giao Dịch
    typeBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            typeBtns.forEach(b => {
                b.classList.remove('bg-expense', 'bg-income', 'bg-primary', 'text-white');
                b.classList.add('bg-gray-700', 'text-gray-300');
            });
            
            appState.currentTxnType = e.target.getAttribute('data-type');
            e.target.classList.remove('bg-gray-700', 'text-gray-300');
            e.target.classList.add('text-white');
            
            if (appState.currentTxnType === 'expense') e.target.classList.add('bg-expense');
            if (appState.currentTxnType === 'income') e.target.classList.add('bg-income');
            if (appState.currentTxnType === 'transfer') e.target.classList.add('bg-primary');
            
            // Reset Category và Tag khi đổi loại
            appState.formState.category = { id: null, name: 'Select...' };
            appState.formState.tag = { id: null, name: 'Optional...' };
            updateFormDisplay();
        });
    });

    // LƯU GIAO DỊCH 
    btnSaveTxn.addEventListener('click', async () => {
        const amountStr = document.getElementById('txn-amount').value.replace(/,/g, '');
        const amount = Number(amountStr);
        const date = document.getElementById('txn-date').value;
        const remark = document.getElementById('txn-remark').value;

        if (!amount || amount <= 0) { showToast('Invalid amount!', 'error'); return; }
        if (!appState.formState.wallet.id) { showToast('Please select Wallet!', 'error'); return; }
        if (!date) { alert('Vui lòng chọn Ngày giao dịch!'); return; }

        let transferReceivedAmount = amount;
        if (appState.currentTxnType === 'transfer') {
            if (!appState.formState.walletTo.id) { showToast('Please select Destination Wallet!', 'error'); return; }
            if (appState.formState.wallet.id === appState.formState.walletTo.id) { showToast('Source and Destination wallets must be different!', 'error'); return; }
            
            const fromCur = appState.formState.wallet.currency;
            const toCur = appState.formState.walletTo.currency;
            
            if (fromCur !== toCur) {
                const trAmountStr = document.getElementById('txn-transfer-amount').value.replace(/,/g, '');
                transferReceivedAmount = Number(trAmountStr);
                if (!transferReceivedAmount || transferReceivedAmount <= 0) {
                    showToast(`Please enter received amount in ${toCur}`, 'error');
                    return;
                }
            }
        } else {
            if (!appState.formState.category.id) { alert('Vui lòng chọn Category!'); return; }
        }

        if (appState.currentTxnType === 'transfer' && appState.editingTxnId) {
            // Chúng ta hỗ trợ Edit bằng cách tự động XOÁ và TẠO MỚI lại giao dịch
        }

        btnSaveTxn.innerText = "Saving...";
        btnSaveTxn.disabled = true;

        try {
            let finalWalletId = appState.formState.wallet.id;
            let finalCategoryId = appState.formState.category.id;
            let finalTagId = appState.formState.tag.id;

            if (finalWalletId === 'NEW') {
                const newWallet = await createWalletApi(appState.formState.wallet.name);
                if (newWallet) finalWalletId = newWallet.id;
            }
            if (finalCategoryId === 'NEW') {
                const newCat = await createCategory(appState.formState.category.name, appState.currentTxnType);
                if (newCat) finalCategoryId = newCat.id;
            }
            if (finalTagId === 'NEW') {
                const newTag = await createTag(appState.formState.tag.name, finalCategoryId);
                if (newTag) finalTagId = newTag.id;
            }

            const currentCurrency = appState.formState.wallet.currency || 'VND';
            let rate = 1;
            let finalBaseAmount = amount;

            if (currentCurrency !== 'VND') {
                rate = appState.exchangeRatesCache[currentCurrency] || 1;
                finalBaseAmount = Math.round(amount * rate);
            }

            const txnData = {
                type: appState.currentTxnType,
                amount: amount,
                currency: currentCurrency,
                base_amount: finalBaseAmount,
                exchange_rate: rate,
                wallet_id: finalWalletId,
                category_id: finalCategoryId,
                tag_id: (!finalTagId || finalTagId === 'NEW') ? null : finalTagId,
                // Snapshot tên để bảo toàn lịch sử khi category/tag bị xóa sau này
                category_name: appState.formState.category.name && appState.formState.category.name !== 'Select...' ? appState.formState.category.name : null,
                tag_name: appState.formState.tag.name && appState.formState.tag.name !== 'Optional...' ? appState.formState.tag.name : null,
                remark: remark,
                transaction_date: date
            };

            let isSuccess = false;

            // Xử lý Xóa giao dịch cũ nếu đang Edit mà dính líu đến Transfer (từ cũ hoặc mới)
            let oldTxnForUpdate = null;
            if (appState.editingTxnId) {
                oldTxnForUpdate = appState.currentTransactionsList.find(t => t.id === appState.editingTxnId);
                
                if (oldTxnForUpdate && (oldTxnForUpdate.linked_txn_id || appState.currentTxnType === 'transfer')) {
                    const delSuccess = await deleteTransactionAndRefund(oldTxnForUpdate);
                    if (!delSuccess) {
                        btnSaveTxn.innerText = "Save Transaction";
                        btnSaveTxn.disabled = false;
                        showToast('System Error: Lỗi hoàn tiền cũ khi Edit Transfer', 'error');
                        return;
                    }
                    // Chuyển cờ edit về null để luồng dưới coi như là Tạo Mới
                    appState.editingTxnId = null;
                }
            }
            
            if (appState.currentTxnType === 'transfer') {
                const fromCur = appState.formState.wallet.currency;
                const toCur = appState.formState.walletTo.currency;
                
                let fromBaseAmount = amount;
                if (fromCur !== 'VND') {
                    fromBaseAmount = Math.round(amount * (appState.exchangeRatesCache[fromCur] || 1));
                }

                let toBaseAmount = transferReceivedAmount;
                if (toCur !== 'VND') {
                    toBaseAmount = Math.round(transferReceivedAmount * (appState.exchangeRatesCache[toCur] || 1));
                }

                const fromTxnData = {
                    type: 'expense',
                    amount: amount,
                    currency: fromCur,
                    base_amount: fromBaseAmount,
                    exchange_rate: appState.exchangeRatesCache[fromCur] || 1,
                    wallet_id: finalWalletId,
                    category_id: null,
                    tag_id: null,
                    remark: remark || `Transfer to ${appState.formState.walletTo.name}`,
                    transaction_date: date
                };

                const toTxnData = {
                    type: 'income',
                    amount: transferReceivedAmount,
                    currency: toCur,
                    base_amount: toBaseAmount,
                    exchange_rate: appState.exchangeRatesCache[toCur] || 1,
                    wallet_id: appState.formState.walletTo.id, // wait what if target wallet 'NEW'? Well we don't allow NEW for 'target' via UI since we only have one wallet picker logic... actually walletTo allows NEW. We should handle it!
                    category_id: null,
                    tag_id: null,
                    remark: remark || `Transfer from ${appState.formState.wallet.name}`,
                    transaction_date: date
                };

                // Handle walletTo NEW correctly
                if (appState.formState.walletTo.id === 'NEW') {
                    const newToWallet = await createWalletApi(appState.formState.walletTo.name);
                    if (newToWallet) toTxnData.wallet_id = newToWallet.id;
                }

                isSuccess = await saveTransferToDB(fromTxnData, toTxnData);

            } else {
                if (appState.editingTxnId && oldTxnForUpdate) {
                    isSuccess = await updateTransactionFull(oldTxnForUpdate, txnData);
                } else {
                    isSuccess = await saveTransactionToDB(txnData);
                }
            }

            if (isSuccess) {
                showToast(appState.editingTxnId ? 'Updated successfully!' : 'Saved successfully!', 'success');
                
                document.getElementById('txn-amount').value = '';
                document.getElementById('txn-remark').value = '';
                const transferAmountEl = document.getElementById('txn-transfer-amount');
                if (transferAmountEl) transferAmountEl.value = '';

                appState.editingTxnId = null; 
                document.getElementById('btn-save-txn').innerText = "Save Transaction"; 
                
                appState.formState = { 
                    wallet: { id: null, name: 'Select...', currency: 'VND' }, 
                    walletTo: { id: null, name: 'Select...', currency: 'VND' }, 
                    category: { id: null, name: 'Select...' }, 
                    tag: { id: null, name: 'Optional...' } 
                };
                updateFormDisplay();
                
                document.getElementById('btn-close-modal').click();
                
                // Reload tất cả tabs đang active
                if (window.refreshAllActiveViews) window.refreshAllActiveViews();
            } else {
                showToast('Lỗi lưu giao dịch. Vui lòng check Console.', 'error');
            }
        } catch (error) {
            console.error('[UI] Lỗi Exception khi Save:', error);
            alert('Đã xảy ra lỗi hệ thống!');
        } finally {
            btnSaveTxn.innerText = "Save Transaction";
            btnSaveTxn.disabled = false;
        }
    });

}
